module.exports = __webpack_public_path__ + "static/media/school_early.54f08730.svg";